import Country from './country';
import Entity from './entity';
export default class City extends Entity<string> {
  name: string;
  countryId: string;
  expediaId: number;
  coordinate: string;
  country: Country;
  creationTime: string;
  creatorUserId: any;
}
